export default __webpack_public_path__ + "static/media/OE.8cfaa818.png";